import cn from 'classnames';
import styles from './DeliveryServiceDescription.module.scss';
import { DeliveryServiceType } from '@/types';

type DeliveryServiceDescriptionProps = {
  className?: string;
  delivery: DeliveryServiceType;
};

export function DeliveryServiceDescription({
  className,
  delivery,
}: DeliveryServiceDescriptionProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  return (
    <div className={wrapperClassName}>
      <div className={styles.name}>
        <img src="/svg/star.svg" alt="star" className={styles.star} />
        <span className={styles.text}>{delivery.name}</span>
      </div>
      <div className={styles.row}>
        <span className={styles.text}>{delivery.price.text}</span>
        <div className={styles.dots} />
        <span className={styles.text}>{delivery.price.value}</span>
      </div>
      <div className={styles.row}>
        <span className={styles.text}>{delivery.free.text}</span>
        <div className={styles.dots} />
        <span className={styles.text}>{delivery.free.value}</span>
      </div>
      <div className={styles.row}>
        <span className={styles.text}>{delivery.time.text}</span>
        <div className={styles.dots} />
        <span className={styles.text}>{delivery.time.value}</span>
      </div>
    </div>
  );
}
